import { useCallback, useEffect, useState } from "react";
import { Loader2, X } from "lucide-react";
import { MessageItem } from "./MessageItem";
import { Composer } from "./Composer";
import { capi } from "./chatApi";

export const ThreadPanel = ({ root, channel, me, people, names, onClose, onAction, onImage, onChanged }) => {
  const [d, setD] = useState(null);
  const load = useCallback(() => capi("get", `/chat/thread/${root.id}`).then(setD).catch(() => {}), [root.id]);
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, [load]);
  return (
    <aside className="flex w-full flex-col border-l bg-white md:w-96" data-testid="chat-thread-panel">
      <div className="flex items-center border-b px-4 py-3"><b className="flex-1">Thread</b><button onClick={onClose} className="rounded p-1 hover:bg-slate-100" data-testid="chat-thread-close"><X className="h-4 w-4" /></button></div>
      <div className="flex-1 space-y-1 overflow-y-auto p-2">
        {!d ? <Loader2 className="mx-auto mt-6 h-4 w-4 animate-spin text-slate-400" /> : <>
          <MessageItem m={d.root} me={me} names={names} inThread onAction={onAction} onImage={onImage} />
          <div className="my-2 flex items-center gap-2 px-2 text-[11px] text-slate-400"><span className="h-px flex-1 bg-slate-200" />{d.replies.length} repl{d.replies.length === 1 ? "y" : "ies"}<span className="h-px flex-1 bg-slate-200" /></div>
          {d.replies.map((m) => <MessageItem key={m.id} m={m} me={me} names={names} inThread onAction={(a, x) => { onAction(a, x); setTimeout(load, 400); }} onImage={onImage} />)}
        </>}
      </div>
      <Composer channel={channel} threadId={root.id} people={people} placeholder="Reply in thread…" testid="chat-thread" partnerQid={root.link?.kind === "parcel_query" && !root.link?.done ? root.link.id : null} onSent={() => { load(); onChanged(); }} />
    </aside>
  );
};
